import * as React from 'react';
import { StyledWrapperContainer } from './WrapperContainer.style';

export interface WrapperContainerProps {
  children?: React.ReactNode;
  [key: string]: any;
}

const WrapperContainer: React.FC<WrapperContainerProps> = ({children, ...style }) => {
  return (
    <StyledWrapperContainer {...(style as any)}>{children}</StyledWrapperContainer>
  );
};

export default WrapperContainer;